import { Component, Inject, Vue } from "vue-property-decorator";
import {
  FILTER_SEARCH_PATIENT_CONSTANTS,
  SEARCH_PATIENT_CONSTANTS
} from "./constants/SearchPatientConstants";
import { UserService } from "@/modules/User/services/UserService";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import Snackbar from "../Snackbar/Snackbar";
import { PROFILE_CONSTANTS } from "@/modules/Profile/constants/ProfileConstants";
import {
  USER_ACCESS,
  USER_CONSTANTS,
  USER_STATES
} from "@/modules/User/constants/UserConstants";
import SearchOneFilter from "./../GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import {
  FilterOneItem,
  ItemByCreate,
  QueryFilter
} from "../GenericSearchBar/model/FilterOneItem";
import { UserStatus } from "@/modules/User/models/UserStatus";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "./../../constants/GeneralConstants";

@Component({
  name: "SearchPatient",
  components: { SearchOneFilter }
})
export default class SearchPatient extends Vue {
  @Inject() userService!: UserService;

  clearAll = 0;

  PATIENT_SEARCH_NADBAR_KEY = NAME_FINDERS.PATIENT_SEARCH_NADBAR;
  userId = "";
  itemFilter: FilterOneItem = {
    ...FILTER_SEARCH_PATIENT_CONSTANTS,
    getData: this.getPatientData
  };

  async getPatientData(query: QueryFilter): Promise<UserStatus[]> {
    let listPatient: UserStatus[] = [];
    try {
      const filterQuery = {
        ...query,
        ...SEARCH_PATIENT_CONSTANTS.FILTER_QUERY_DEFAULT,
        userState: USER_STATES.ACTIVE
      };
      const responseData = await this.userService.getUserByFilters(filterQuery);
      if (responseData.code === Http.Found && responseData.data) {
        const users = responseData.data.userArray;
        this.userId =
          query.userDocument && users.length == 1 && !users[0].externalUser
            ? users[0].id
            : "";
        listPatient = this.userId ? [] : users;
      } else {
        this.userId = "";
      }
      this.itemFilter.labelAddTitleOptional = this.userId
        ? SEARCH_PATIENT_CONSTANTS.MESSAGE.USER_NO_PATIENT
        : "";
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    return listPatient;
  }

  selectItem(item: UserStatus) {
    this.selectPatient(item.id);
  }

  selectPatient(idPatient: string) {
    if (
      !this.$route ||
      !this.$route.params ||
      !this.$route.params.id ||
      (idPatient && idPatient != this.$route.params.id)
    ) {
      this.$router.push(`${PROFILE_CONSTANTS.PATH}/${idPatient}`);
    }
    this.clearAll = 1 - this.clearAll;
  }

  createNewUser({ searchText }: ItemByCreate) {
    this.$router
      .push({
        path: `${USER_CONSTANTS.USER_ROUTE}/${searchText}/${this.userId}`
      })
      .catch(() => {
        this.clearAll = 1 - this.clearAll;
      });
  }
}
